<template>
  <div class="position-relative">
    <template v-if="!user">
      <input type="text" placeholder="Rechercher" v-model="search" class="form form-control">
    </template>
    <template v-else>
      <div class="d-flex align-items-center justify-content-between bg-light-primary border border-primary p-2 px-5 rounded border-primary">
        <div>
          <div class="fw-bolder">
            {{ user.name }} {{ user.prename }} &nbsp;
          </div>
          <div class="fw-bolder text-muted fs-8">
            {{ user.email }} &nbsp;
          </div>
        </div>
        <div @click="restore" class="cursor-pointer text-hover-danger">
          <i class="fad fa-times fs-2"></i>
        </div>
      </div>
    </template>
    <div class="border-rounded mh-300px overflow-auto mt-5" style="width:100%;top:100%;right:0" v-if="search && !user">
      <template v-for="user of matches">
        <div v-if="isUserMatchSearch(user)" @click="setUser(user)" class="px-3 bg-hover-light-primary d-flex align-items-center justify-content-between border-top">
          <div class=" py-2 ">
            <div class="fw-bolder">
              {{ user.name }} {{ user.prename }} &nbsp;
            </div>
            <div class="fw-bolder text-muted fs-8">
              {{ user.email }} &nbsp;
            </div>
          </div>
          <div>
            <i class="fad fa-angle-right fs-2"></i>
          </div>
        </div>
      </template>
      <template v-if="matches.length === 0">
        <div class="text-center">
          <div>
            <i class="fad fa-empty-set fs-3x"></i>
          </div>
          <div class="mt-5">
            Aucun Utilisateur correspondant
          </div>
        </div>
      </template>
    </div>
  </div>


</template>


<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import {helper} from "@/services/Helper";
import {api} from "@/services/Api";
import User from "@/entity/User";
import {auth} from "@/services/Auth";

@Component({})
export default class UserSelector extends Vue {
  @Prop({default: ''}) value?: string;
  users: User[] = []
  search = ''
  user: any = null

  async mounted() {
    this.users = await api.loadManagers()
  }

  get matches() {
    if (helper.empty(this.search)) {
      return this.users
    }
    return this.users.filter((user: any) => {
      return (user.name.trim().toLowerCase().includes(this.search.toLowerCase()) ||
              (user.prename.trim().toLowerCase().includes(this.search.toLowerCase())) ||
              (user.email.trim().toLowerCase().includes(this.search.toLowerCase())))
          && (auth.getCurrentUser()?.id !== user.id)
    })
  }

  isUserMatchSearch(user: any) {
    return true
  }

  setUser(user: any) {
    this.user = user
    this.search = ''
    this.$emit('input',user.email)
    this.$emit('user',user)
  }

  restore() {
    this.user = null
  }


}
</script>


<style scoped>

</style>
